<template>
    <div>
        <audio id="audio_message" src="/sounds/message.mp3"></audio>
        <div>
            <div class="tab mb-0">
                <ul class="nav nav-tabs" role="tablist">
                    <li @click="active_tab = k" v-for="(c,k) in chats" :key="c.id" class="nav-item" :class="{'active': active_tab === k}" style="position: relative">
                        <a class="nav-link" :class="{'active': active_tab === k}" :href="'#request-chat-tab-' + c.id" data-toggle="tab" role="tab">
                            <i v-if="c.type === 'telegram'" class="fab fa-telegram" style="color: #2AABEE"></i>
                            <i v-if="c.type === 'whatsapp'" class="fab fa-whatsapp" style="color: #25D366;"></i>
                            <span>{{c.destination}}</span>
                            <span style="position: absolute;top: 1px;font-size: 8px;white-space: nowrap;right: 4px;opacity: 0.2;">аккаунт #{{c.chat_account_id}}</span>
                        </a>
                    </li>
                    <li v-if="$hasPermission('requests.chats.send_message')" @click="active_tab = 'new'" :class="{'active': active_tab === 'new'}" class="nav-item" style="position: relative">
                        <a class="nav-link" :class="{'active': active_tab === 'new'}" :href="'#request-chat-tab-new'" data-toggle="tab" role="tab">
                            Начать новый чат
                        </a>
                    </li>
                </ul>
            </div>
            <div class="tab-content">
                <div v-for="(c,k) in chats" :key="c.id" class="tab-pane fade show" :class="{'active': active_tab === k}" :id="'request-chat-tab-' + c.id" role="tabpanel">
                    <Chat @incoming="handleIncoming" :chat="c" :request="request" />
                </div>
                <div class="tab-pane fade show" :class="{'active': active_tab === 'new'}" :id="'request-chat-tab-new'" role="tabpanel">
                    <Chat :request="request" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chat from "../chats/Chat";
export default {
    name: "RequestChatBlock",
    components: {Chat},

    props: ['request'],
    data: () => ({
        chats: [],
        active_tab: 'new',
    }),
    mounted() {
        let self = this;
        Echo.private('request.' + this.request.id)
            .listen('.chat.created', function (e) {
                self.fetchChats();
                try {
                    audio_message.play();
                } catch (e) {

                }
            });
        this.fetchChats();
    },
    beforeDestroy() {
        Echo.leave('request.' + this.request.id);
    },
    computed: {

    },
    methods: {
        fetchChats() {
            let self = this;
            axios.get('/api/chats/request/' + this.request.id)
                .then(r => {
                    self.chats = r.data
                    if (self.chats.length) self.active_tab = self.chats.length - 1
                })
        },
        handleIncoming(m) {
            this.chats.forEach((c,k) => {
                if (m.chat_id === c.id) this.active_tab = k;
            })
            try {
                audio_message.play();
            } catch (e) {

            }
        }
    }
}
</script>

<style>
#chat2 .form-control {
    border-color: transparent;
}

#chat2 .form-control:focus {
    border-color: transparent;
    box-shadow: inset 0px 0px 0px 1px transparent;
}

.divider:after,
.divider:before {
    content: "";
    flex: 1;
    height: 1px;
    background: #eee;
}
</style>
